import identity from 'lodash-es/identity';
export const defaultIfEmpty = <T>(array: Array<T>, defaultValue?: T): Array<T> => {
  if (array == null || !array.length) {
    return [defaultValue] as Array<T>;
  }
  return array.filter(identity);
};
